import { useMutation } from '@tanstack/react-query';
import { createBugReport } from '../../api';

export function useCreateBugReport() {
  return useMutation({
    mutationFn: createBugReport,
    onError: (error) => {
      // Keep the underlying failure detail in the browser console for triage;
      // the UI surfaces the BFF-provided message, which is already sanitized
      // server-side and never leaks Azure internals.
      console.error('Bug report submission failed', error);
    },
  });
}
